module.exports = __webpack_public_path__ + "static/img/8.5d9fce3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/8.png
// module id = obQo
// module chunks = 0